import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import ResetPasswordForm from './ResetPasswordForm'
import Well from '../common/Well'
import PromoBanner from '../common/PromoBanner'
import Footer from '../layout/Footer'
import { resetPassword, clearPasswordResetState } from '../../actions/login'
import { validateResetPassword } from '../../utils/validators'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import adLeaderImage from '../../../assets/images/login_banner.jpg'
import styles from './common.module.css'

function ResetPassword({ appName, inProgress, error, passwordResetSuccess, resetPassword, clearPasswordResetState }) {
  const navigate = useNavigate()
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [validationErrors, setValidationErrors] = useState({})

  // index.html has already taken the token out of the URL; it lives on
  // window so a remount still finds it.
  const token = (window.__gemsbyReset && window.__gemsbyReset.token) || null

  useEffect(() => {
    return () => {
      clearPasswordResetState()
    }
  }, [])

  useEffect(() => {
    if (passwordResetSuccess) {
      toast.success('Password reset successfully! Please log in with your new password.', {
        position: 'top-right',
        autoClose: 3000,
        onClose: () => {
          navigate('/login')
        }
      })
    }
  }, [passwordResetSuccess, navigate])

  const handleChange = fieldName => event => {
    const val = event.target.value
    if (validationErrors[fieldName]) {
      setValidationErrors(prev => { const next = { ...prev }; delete next[fieldName]; return next })
    }
    if (fieldName === 'password') setPassword(val)
    if (fieldName === 'confirmPassword') setConfirmPassword(val)
  }

  const handleSubmit = () => {
    const { valid, error: valErr } = validateResetPassword({ password, confirmPassword })
    if (!valid) {
      setValidationErrors(valErr)
      return
    }
    setValidationErrors({})
    resetPassword(token, password, confirmPassword)
  }

  const mergedError = { ...validationErrors, message: error && error.message, token: error && error.token }

  return (
    <div id="extr-page">
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <header id="header" className={styles.header}>
        <div className={styles.headerWrapper}>
          <div className={styles.logo} />
          <h1 className={styles.appName}>
            {appName}
          </h1>
        </div>
      </header>

      <div id="main" role="main" className={styles.main}>
        <div className={styles.form}>
          <Well className="no-padding">
            <ResetPasswordForm
              onChangeFactory={handleChange}
              inProgress={inProgress}
              error={mergedError}
              onSubmit={handleSubmit}
              tokenMissing={!token}
            />
          </Well>
        </div>
      </div>

      <PromoBanner
        className={styles.ad}
        imgSrc={adLeaderImage}
        // url="https://mydiamond.app.link/login_leader"
      />

      <Footer />
    </div>
  )
}

const mapStateToProps = ({ login }) => ({
  inProgress: login.get('inProgress'),
  error: login.get('error') || {},
  passwordResetSuccess: login.get('passwordResetSuccess')
})

const mapDispatchToProps = {
  resetPassword,
  clearPasswordResetState
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword)
